<template>
  <component
    :is="as"
    class="icon-link"
    :class="{ reverse }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <span>
      <slot />
    </span>

    <icon :name="icon" />
  </component>
</template>

<script>
import Icon from './Icon';

export default {
  components: {
    Icon,
  },

  props: {
    as: {
      type: String,
      default: 'a',
    },
    icon: {
      type: String,
      default: 'chevron_right',
    },
    reverse: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.icon-link {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-weight: bold;
  font-size: 14px;
  text-decoration: none !important;
  color: var(--theme-color);

  .icon {
    margin-left: $gp * .25;
    font-size: 22px;
  }

  &:hover {
    text-decoration: none;

    span {
      text-decoration: underline;
    }
  }

  &.reverse {
    flex-direction: row-reverse;

    .icon {
      margin-left: 0;
      margin-right: $gp * .25;
    }
  }
}
</style>
